import { useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";

const VIDEOS = [
  {
    id: "OFx9qNee4hw",
    title: "Open Source Summit",
    meta: "Prague · International technology keynote",
    thumb: "https://i.ytimg.com/vi/OFx9qNee4hw/hqdefault.jpg",
  },
  {
    id: "DQ8NNmOVFuE",
    title: "Los Angeles City Hackathon",
    meta: "City of Los Angeles · Technology, innovation, and civic engagement",
    thumb: "/thumb-hackathon.webp",
  },
  {
    id: "byw-7jBw54U",
    title: "Kids Day Technology Program",
    meta: "Vancouver · Teaching the next generation of technologists",
    thumb: "/thumb-vancouver.webp",
  },
];

export default function Videos() {
  const [active, setActive] = useState(null);

  return (
    <section id="videos" data-testid="videos-section" className="py-32 lg:py-40 bg-muted/60">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.p initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, ease: "easeOut" }} className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-accent">
          Watch
        </motion.p>
        <motion.h2 initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }} className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none mt-6 max-w-3xl">
          See Phillip <span className="italic text-primary">in action.</span>
        </motion.h2>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-10">
          {VIDEOS.map((v, i) => (
            <motion.figure
              key={v.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: "easeOut" }}
              data-testid={`video-card-${i}`}
            >
              <div className="overflow-hidden rounded-xl border border-[#D8D4CA] aspect-video bg-[#2C2A29]">
                {active === v.id ? (
                  <iframe
                    src={`https://www.youtube-nocookie.com/embed/${v.id}?autoplay=1&rel=0`}
                    title={v.title}
                    loading="lazy"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="w-full h-full"
                  />
                ) : (
                  <button
                    onClick={() => setActive(v.id)}
                    data-testid={`video-play-${i}`}
                    className="relative w-full h-full group cursor-pointer"
                    aria-label={`Play ${v.title}`}
                  >
                    <img
                      src={v.thumb}
                      alt={v.title}
                      loading="lazy"
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                    />
                    <span className="absolute inset-0 flex items-center justify-center">
                      <span className="w-16 h-16 rounded-full bg-primary/95 flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-black/30">
                        <Play className="w-7 h-7 text-white fill-white ml-1" />
                      </span>
                    </span>
                  </button>
                )}
              </div>
              <figcaption className="mt-5">
                <div className="font-display text-2xl tracking-tight">{v.title}</div>
                <div className="text-sm text-foreground/60 mt-1">{v.meta}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
